import axios from "axios";
import { parseAllDateFields } from "./ParseAllDateFields";
import { ProjectViewModel } from "../ViewModel/ProjectViewModel";
import fixLtlRoutingIdInLtlPipelines from "./FixLtlRoutingIdInLtlPipelines";
import { initLtlPipelines } from "./InitLtlPipelines";
import { getRouteWithOriginRegion } from "./GetRouteWithOriginRegion";
import { FtlRouteViewModel } from "../ViewModel/FtlRouteViewModel";
import { getTemplateFtlRoutes } from "./GetTemplateFtlRoutes";
import { updateSpdrFTLIdentifier } from "./LeftSide/UpdateSpdrFTLIdentifier";
import { updatePdsrFTLIdentifier } from "./handleCardOnDragEnd/updatePdsrFTLIdentifier";
import { projectUrls } from "../../URL/ApplicationUrls";

async function getRoutesWithOriginRegion(
  ftlRoutes: FtlRouteViewModel[],
  startDateDisplay?: string
): Promise<Awaited<FtlRouteViewModel>[]> {
  const routesWithOriginRegion = await Promise.all(
    ftlRoutes.map(async (route: FtlRouteViewModel) => {
      const routeWithOriginRegion = getRouteWithOriginRegion(
        route,
        startDateDisplay
      );
      return (await routeWithOriginRegion) as FtlRouteViewModel;
    })
  );
  return routesWithOriginRegion;
}

async function getProjectFromServer(
  id: string | undefined
): Promise<ProjectViewModel> {
  const response = await axios.get(projectUrls.projectWithId(id).apiUrl);
  if (response.status !== 200) {
    throw new Error("Network response was not ok");
  }

  return (await response.data) as ProjectViewModel;
}

export async function getProject({
  id,
  handleUpdateProject,
}: {
  id: string | undefined;
  handleUpdateProject: (updateProject: ProjectViewModel) => void;
}) {
  let project = await getProjectFromServer(id);
  project = parseAllDateFields(project);
  project = initLtlPipelines(project);
  project = {
    ...project,
    ltlPipelines: fixLtlRoutingIdInLtlPipelines(project.ltlPipelines),
  };

  const ftlRoutes = [...(project.FTLRoutes || [])];
  const routesWithOriginRegion = await getRoutesWithOriginRegion(
    ftlRoutes,
    project.StartDateDisplay
  );
  project = {
    ...project,
    FTLRoutes: routesWithOriginRegion,
    TemplateFTLRoutes: await getTemplateFtlRoutes(routesWithOriginRegion),
  };

  project = updateSpdrFTLIdentifier(project);
  project = updatePdsrFTLIdentifier(project);

  handleUpdateProject(project);
}
